import React, { Component } from 'react';
import { Icon } from 'semantic-ui-react';

import { __ } from '../../lib/I18n';

/**
 * @typedef {{
 *  value: string,
 *  sendTo: string,
 *  loginType: string,
 *  onChange: (email: string) =>void,
 *  onConfirm: () => void,
 *  onError: (hide: boolean) => void,
 *  resendCode: () => void,
 * }} Props
 * @extends {Component<Props>}
 */
export default class TokenInput extends React.Component {
  /** @param {Props} props */
  constructor(props) {
    super(props);

    this.state = {
      error: null,
    };
  }

  /**
   * @param {string} token
   * @returns {boolean}
   */
  validate = (token) => {
    if (!token.trim() || token.length !== 6) {
      this.onError();
      return false;
    }

    return true;
  };

  onConfirm = () => {
    const { value, onConfirm } = this.props;

    if (this.validate(value)) onConfirm();
  };

  onError = () => {
    const { onError } = this.props;
    onError(true);
    this.setState({ error: __('Código incorreto. ') });
  };

  render() {
    const { error } = this.state;
    const { value, onChange, sendTo, loginType } = this.props;

    return (
      <div
        className={`input-component ${error ? 'error' : ''}`}
        style={{ marginBottom: '2.5rem', maxWidth: '23rem', width: '100%' }}
      >
        <p style={{ fontWeight: 400, color: 'rgba(0, 0, 0, 0.6)', marginBottom: '.8rem' }}>
          {__(
            'Enviamos um código com 6 dígitos via %s ',
            loginType === 'email' ? __('email para') : __('SMS para o número')
          )}
          <b>{sendTo}</b>
        </p>
        <div className="text-input">
          <input
            placeholder="* * * * * *"
            value={value}
            type="text"
            maxLength={6}
            onChange={/** @param {any} e */(e) => {
              if (error) this.setState({ error: '' });
              onChange(e.target.value);
            }}
            onKeyPress={(e) => e.key === 'Enter' && this.onConfirm()}
            style={{ display: 'flex', textAlign: 'center' }}
          />
        </div>
        {error && (
          <div
            className="error-warning"
            style={{
              maxWidth: '23rem',
              width: '100%',
              marginTop: '1rem',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <Icon className="circle exclamation" />
            <p>
              {error}
              {__('Tente novamente ou solicite um novo código.')}
            </p>
          </div>
        )}
      </div>
    );
  }
}
